import React from 'react';
import { motion } from 'framer-motion';
import { StageBackgroundProps } from '../../types/judge';

/**
 * Vibrant animated background with stage lighting effects
 * Creates a theatrical atmosphere with moving gradients and spotlight effects
 */
const StageBackground: React.FC<StageBackgroundProps> = ({ className = '' }) => {
  return (
    <div className={`fixed inset-0 -z-10 ${className}`}>
      {/* Base gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-purple-900/20 to-pink-900/20" />
      
      {/* Static spotlight effects - animations disabled for performance */}
      <div
        className="absolute inset-0"
        style={{
          background: "radial-gradient(circle at 20% 30%, rgba(236, 72, 153, 0.15) 0%, transparent 50%)"
        }}
      />
      
      {/* Stage floor reflection */}
      <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
    </div>
  );
};

export default StageBackground;
